//
// PickResultEntry.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";
import "../models/data/DataValue";
import "./PickResultEntryDisplayRuleIndicator";

var PickResultEntry = createModule("commons::PickResultEntry", [], ClosetObject, [
    ,
    ,
    ,
    {
        displayRuleIndicator: 1,
        useAsTooltip: 2,
        formattedValue: 7,
        legendSVG: 7,
        label: 7,
        value: 1,
    },
    ,
    {
        _create: [4],
    },
    ,
]);
export default PickResultEntry;
